// extracted by mini-css-extract-plugin
module.exports = {"animationA":"animationA_animationA__Q_1ZE"};